import { render, staticRenderFns } from "./CopyrightAmendmentFormFilesEscalated.vue?vue&type=template&id=5b45a805&scoped=true&"
import script from "./CopyrightAmendmentFormFilesEscalated.vue?vue&type=script&lang=js&"
export * from "./CopyrightAmendmentFormFilesEscalated.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAmendmentFormFilesEscalated.vue?vue&type=style&index=0&id=5b45a805&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b45a805",
  null
  
)

export default component.exports